var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 22,
    rx: 10.5,
    fill: "#C5CAFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2393 12.696C11.3113 13.416 11.5993 13.992 12.1033 14.436C12.6073 14.88 13.2073 15.096 13.9153 15.096C14.7193 15.096 15.3673 14.844 15.8713 14.34C16.3753 13.824 16.6273 13.164 16.6273 12.36C16.6273 11.592 16.4113 10.968 15.9913 10.5C15.5713 10.02 15.0433 9.78 14.3953 9.78C14.2393 9.78 14.1313 9.792 14.0593 9.816L16.1953 6.924V6.6H11.6353V7.56H14.6593L12.7513 10.176L13.1713 10.74C13.3873 10.632 13.6393 10.584 13.9153 10.584C14.9353 10.584 15.5953 11.22 15.5953 12.36C15.5953 13.476 14.9233 14.136 13.9153 14.136C12.9553 14.136 12.4033 13.608 12.2473 12.564L11.2393 12.696Z",
    fill: "#0E22F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.af3973e0.svg";
export { ForwardRef as ReactComponent };